import FinancialReportStructure from "../components/FinancialReporting/FinancialReportStructure";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import * as actions from "../common/actions";
import { All, KeyValue } from "../interfaces";

function mapStateToProps({ appState }: All) {
  return {
    appState: (appState as KeyValue)[appState.app],
  };
}

function mapDispatchToProps(dispatch: Dispatch<actions.AllActions>) {
  return {
    updateReportDownloadData: (data: (string[] | number[])[]) => {
      dispatch(actions.updateUi("reportDownload", data));
    },
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(FinancialReportStructure);
